import caDispatcher from '../action/ca';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const caReducer = caDispatcher(initialState, {
  [caDispatcher.getDataSuccess]: (state, payload) => {
    const data = payload?.data;

    /* `users/filter` can answer 200 with a null body. Keep the previous paging
       instead of replacing it with `{ list: undefined }`, which would wipe
       pageIndex/pageSize and leave the pager stuck. */
    if (!data) return { ...state, list: [] };

    return {
      list: (data.list || []).map((i) => ({
        ...i,
        // lstClinic is absent for a CA not assigned to any clinic.
        lstClinicId: (i.lstClinic || []).map((c) => c.id),
      })),
      paging: {
        ...data,
        list: undefined,
      },
    };
  },
});

export default caReducer;
